// extracted by mini-css-extract-plugin
export default {"container":"Freeswitch_container__DJyLr","containerInner":"Freeswitch_containerInner__t9b1P","header":"Freeswitch_header__iEyq8"};